<template lang="pug">
el-dialog(title="重置团队角色" :visible="visible" :before-close="hide")
    el-form(:model="form" ref="form")
        el-form-item(label="团队角色" prop="password" label-width="120px")
            el-select.change-teamRole(v-model="form.teamRole" size="medium")
                el-option(v-for="item in teamRoleOptions" :key="item.value" :label="item.label" :value="item.value")
    .dialog-footer(slot="footer")
        el-button(@click="hide") 取 消
        el-button(type="primary", @click="submit", :loading="loading") 确 定
</template>

<script>
// @ is an alias to /src
import { updateTeamMemberAPI } from "@/services";
import { objectExpression } from "babel-types";
const defaultForm = {
    username: "",
    teamRole: "member"
};
export default {
    name: "teamRoleResetForm",
    props: ["visible", "editing", "teamId"],
    data() {
        return {
            loading: false,
            form: Object.assign({}, defaultForm),
            teamRoleOptions: [
                {
                    value: "admin",
                    label: "团队管理员",
                    disabled: false
                },
                {
                    value: "member",
                    label: "团队成员",
                    disabled: false
                }
            ]
        };
    },
    methods: {
        /**
         * Backend Service API Func Wrapper
         */
        async updateTeamMember() {
            this.loading = true;
            try {
                const res = await updateTeamMemberAPI(
                    this.teamId,
                    this.editing.user.name,
                    this._.pickBy(this.form, this._.identity)
                );
                if (res.status === 200) {
                    this.$emit("refresh");
                    this.$message.success("保存成功");
                } else {
                    throw err;
                }
            } catch (err) {
                this.$message.error("服务器开小差了，请尝试重新操作");
            } finally {
                this.loading = false;
            }
        },
        /**
         * UI Control
         */
        hide() {
            this.$emit("hide");
        },
        submit() {
            this.updateTeamMember();
            this.form = Object.assign({}, defaultForm);
            this.hide();
        }
    },
    watch: {
        visible(val) {
            if (val) {
                this.form = Object.assign({}, defaultForm, {
                    username: this.editing.user.name,
                    teamRole: this.editing.teamRole
                });
            } else {
                this.form = Object.assign({}, defaultForm);
            }
        }
    },
    mounted() {}
};
</script>
<style lang="stylus" scoped>
.el-select {
    width: 80%;
}
</style>
